module.exports = __webpack_public_path__ + "img/chevron-3.bba19fa7.webp";